import clsx from 'clsx'
import React, {} from 'react'
import {MenuPosition} from '../hooks/useCoords'
import useTooltip from '../hooks/useTooltip'







const SimpleTooltip = (props) => {
  const {text, children, className} = props
  const {openTooltip, closeTooltip, tooltipPortal, originRef} = useTooltip(
    MenuPosition.UPPER_CENTER
  )

  return (
    React.createElement('div', {
      onMouseEnter: openTooltip,
      onMouseLeave: closeTooltip,
      className: clsx('cursor-pointer', className),
      ref: originRef,}

      , children
      , tooltipPortal(text)
    )
  )
}

export default SimpleTooltip
